module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/standing-icon-90739f744de4975ca68fd1e8df46720b.png";